import React from "react";
import { Alert, Button } from "antd";

const DisplayRectifaction = (props) => {
    const {
        purchaseOrderId,
        purchaseOrderTask,
        task,
        allowEdit,
        includeRectification,
        deleteRectification,
        loading,
    } = props;

    const noRectification = task.payables.find((p) => !p.rectification);
    const rectification = task.payables.find((p) => p.rectification);

    if (purchaseOrderId === rectification.purchase_order_id && purchaseOrderId !== noRectification.purchase_order_id) {
        // correccion incluida en otra PO
        return (
            <Alert
                showIcon
                message={"This is a rectification generated in PO code " + noRectification.purchase_order.code}
                type="info"
            />
        );
    } else if (
        purchaseOrderId === rectification.purchase_order_id &&
        purchaseOrderId === noRectification.purchase_order_id
    ) {
        // correccion no incluida en la misma PO
        return (
            <Alert
                showIcon
                message={"This task has a rectification of " + rectification.subtotal_value + " included is this PO"}
                type="success"
                action={
                    allowEdit && (
                        <Button
                            onClick={() => deleteRectification(purchaseOrderId, purchaseOrderTask.id)}
                            size="small"
                            disabled={loading}
                        >
                            Delete
                        </Button>
                    )
                }
            />
        );
    } else if (purchaseOrderId === noRectification.purchase_order_id && !rectification.purchase_order_id) {
        return (
            <Alert
                showIcon
                message={
                    "This task has a rectification of " + rectification.subtotal_value + " not included is this PO"
                }
                action={
                    allowEdit && (
                        <>
                            {" "}
                            <Button
                                onClick={() => includeRectification(purchaseOrderId, purchaseOrderTask.id)}
                                size="small"
                                disabled={loading}
                            >
                                Include
                            </Button>{" "}
                            <Button
                                onClick={() => deleteRectification(purchaseOrderId, purchaseOrderTask.id)}
                                size="small"
                                disabled={loading}
                            >
                                Delete
                            </Button>{" "}
                        </>
                    )
                }
            />
        );
    } else if (purchaseOrderId === noRectification.purchase_order_id && rectification.purchase_order_id) {
        return (
            <Alert
                showIcon
                message={
                    "This task has a rectification of " +
                    rectification.subtotal_value +
                    " included in PO " +
                    rectification.purchase_order_code
                }
            />
        );
    }
};

export default DisplayRectifaction;
